import { msWordChipBG, white } from '../../../../../styling/theme';

export const filters = {
  MULTI_COLUMN: 'MULTI_COLUMN',
  SINGLE_COLUMN: 'SINGLE_COLUMN',
  IMAGES: 'IMAGES',
  DOCX: 'DOCX',
};

const { MULTI_COLUMN, SINGLE_COLUMN, IMAGES, DOCX } = filters;

export const Attractive = {
  name: 'Attractive',
  type: 'Cover Letter',
  accessType: 'premium',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/AttractiveCoverLetterBW.jpg',
  typeKey: 'coverLetterType',
  to: '/drive/myDrive',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/AttractiveCoverLetterBW.jpg',
  filterType: [MULTI_COLUMN],
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
  ],
};

export const Basic = {
  name: 'Basic',
  type: 'Cover Letter',
  accessType: 'premium',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/BasicCoverLetter1.jpg',
  typeKey: 'coverLetterType',
  to: '/drive/myDrive',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/BasicCoverLetter1.jpg',
  filterType: [SINGLE_COLUMN, DOCX],
  isSupportDocx: true,
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
    {
      color: white,
      bgColor: msWordChipBG,
      text: 'MS Word.',
    },
  ],
  isATSFriendly: true,
};

export const Elegant = {
  name: 'Elegant',
  type: 'Cover Letter',
  accessType: 'premium',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/ElegantCoverLetterUpdate.jpg',
  typeKey: 'coverLetterType',
  to: '/drive/myDrive',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/ElegantCoverLetterUpdate.jpg',
  filterType: [MULTI_COLUMN],
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
  ],
};

export const Emblem = {
  name: 'Emblem',
  type: 'Cover Letter',
  accessType: 'premium',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/EmblemCoverLetter1.jpg',
  typeKey: 'coverLetterType',
  to: '/drive/myDrive',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/EmblemCoverLetter1.jpg',
  filterType: [SINGLE_COLUMN],
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
  ],
  isATSFriendly: true,
};

export const Exemplary = {
  name: 'Exemplary',
  type: 'Cover Letter',
  accessType: 'premium',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/ExemplaryLetter.jpg',
  typeKey: 'coverLetterType',
  to: '/drive/myDrive',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/ExemplaryLetter.jpg',
  filterType: [MULTI_COLUMN],
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
  ],
};

export const Gradient = {
  name: 'Gradient',
  type: 'Cover Letter',
  accessType: 'premium',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/GradientCoverLetter1.jpg',
  typeKey: 'coverLetterType',
  to: '/drive/myDrive',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/GradientCoverLetter1.jpg',
  filterType: [SINGLE_COLUMN],
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
  ],
};

export const Inventor = {
  name: 'Inventor',
  type: 'Cover Letter',
  accessType: 'premium',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/InventorCoverLetter1.jpg',
  typeKey: 'coverLetterType',
  to: '/drive/myDrive',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/InventorCoverLetter1.jpg',
  filterType: [SINGLE_COLUMN, IMAGES],
  chips: [{ color: '#FFFFFF', bgColor: '#473880', text: 'Premium' }],
  isATSFriendly: true,
};

export const Nineties = {
  name: 'Nineties',
  type: 'Cover Letter',
  accessType: 'premium',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/NinetiesCoverLetter.jpg',
  typeKey: 'coverLetterType',
  to: '/drive/myDrive',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/NinetiesCoverLetter.jpg',
  filterType: [MULTI_COLUMN],
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
  ],
};

export const Simple = {
  name: 'Simple',
  type: 'Cover Letter',
  accessType: 'premium',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/SimpleCoverLetter1.jpg',
  typeKey: 'coverLetterType',
  to: '/drive/myDrive',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/SimpleCoverLetter1.jpg',
  filterType: [SINGLE_COLUMN],
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
  ],
  isATSFriendly: true,
};

export const Vintage = {
  name: 'Vintage',
  type: 'Cover Letter',
  accessType: 'premium',
  developed: true,
  imageUrl:
    'https://gatsby.wisedoc.net/craousel_templates/65/VintageCoverLetterNew.png',
  typeKey: 'coverLetterType',
  to: '/drive/myDrive',
  minImage:
    'https://gatsby.wisedoc.net/craousel_templates/65/VintageCoverLetterNew.png',
  filterType: [SINGLE_COLUMN],
  chips: [
    {
      color: '#FFFFFF',
      bgColor: '#473880',
      text: 'Premium',
    },
  ],
  isATSFriendly: true,
};

export const coverLetterTemplates = {
  Attractive,
  Basic,
  Elegant,
  Emblem,
  Exemplary,
  Gradient,
  Inventor,
  Nineties,
  Simple,
  Vintage,
};

export const defaultTemplate = Attractive;

export default [
  Attractive,
  Vintage,
  Nineties,
  Elegant,
  Exemplary,
  Gradient,
  Basic,
  Simple,
  Emblem,
  Inventor,
];
